// legend.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LegendService {
  private legendSubject = new BehaviorSubject<string | null>(null);
  legend$ = this.legendSubject.asObservable();

  setLegend(content: string) {
    localStorage.setItem('legendContent', content);
    this.legendSubject.next(content);
  }

  loadFromStorage() {
    const stored = localStorage.getItem('legendContent');
    if (stored) {
      this.legendSubject.next(stored);
    }
  }
}
